import React, { useState } from 'react'
import { PageMenu } from '../../../../components'
import { IconDocumentacaoBlue } from '../../../../assets/imgs'
import './DocumentacaoMenu.css'
import { IoIosArrowForward, IoIosArrowDown } from 'react-icons/io'
import DocumentationHttp from '../../../../services/documentation/https/documentation.http'

export default function DocumentacaoMenu() {
  const menuItems = []

  const getUrl = number => {
    return DocumentationHttp.getDocumentation(number)
  }

  return (
    <>
      <PageMenu menuItems={menuItems}>
        <img src={IconDocumentacaoBlue} alt="Icon Tela de Dashboard" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>Documentação</span>
      </PageMenu>
      <div className="p-grid" style={{ backgroundColor: '#EFEFEF' }}>
        <ol>
          <ListItem name="Dashboard" total={5} made={5} complete={true}>
            <ListItem name="Status da Operações Logísticas" link={getUrl('1.1')}></ListItem>
            <ListItem name="Expedição TPs" link={getUrl('1.2')}></ListItem>
            <ListItem name="Cargas Paradas TPs" link={getUrl('1.3')}></ListItem>
            <ListItem name="Devoluções Pendentes TPs" link={getUrl('1.4')}></ListItem>
            <ListItem name="Resultado por Empresa" link={getUrl('1.5')}></ListItem>
          </ListItem>
          <ListItem name="Cadastros" disable={false} total={11} made={3}>
            <ListItem name="Clientes" link={getUrl('2.1')}></ListItem>
            <ListItem name="Produtos" link={getUrl('2.2')}></ListItem>
            <ListItem name="Grupo de Produtos" link={getUrl('2.3')}></ListItem>
            <ListItem name="Motoristas" link={getUrl('2.4')}></ListItem>
            <ListItem name="Veículos" link={getUrl('2.5')}></ListItem>
            <ListItem name="Rotas de Entrega" link={getUrl('2.6')}></ListItem>
            <ListItem name="Lista de Envio - Emails" link={getUrl('2.7')}></ListItem>
            <ListItem name="Lead Time Para Recebimento de Carga"></ListItem>
            <ListItem name="Transportadoras"></ListItem>
            <ListItem name="Veiculo Transferência"></ListItem>
            <ListItem name="Motivos de Atraso"></ListItem>
          </ListItem>
          <ListItem name="Entrega" disable={false} total={16} made={2}>
            <ListItem name="Ciclos de Entrega"></ListItem>
            <ListItem name="Transferência de Entrega entre Trechos"></ListItem>
            <ListItem name="Recebimento de Transferência de Entrega"></ListItem>
            <ListItem name="Carregamento de Veículos de Entrega"></ListItem>
            <ListItem name="Emitir Mapa de Carga"></ListItem>
            <ListItem name="Emitir Mapa de Carga - Analítico"></ListItem>
            <ListItem name="Envio de Veículo de Entrega para Rota"></ListItem>
            <ListItem name="Retorno do Veículo de Entrega para Rota"></ListItem>
            <ListItem name="Entregas Por Empresa Analítico"></ListItem>
            <ListItem name="Entregas Para Roteirização"></ListItem>
            <ListItem name="Endereçamento das Entregas - Estoque"></ListItem>
            <ListItem name="Roteirização Prévia das Entregas"></ListItem>
            <ListItem name="Importação Multiplos Ciclos de Entrega"></ListItem>
            <ListItem name="Rastreabilidade Pallet - Entrega"></ListItem>
            <ListItem name="Informações de Horário Saida" link={getUrl('3.15')}></ListItem>
            <ListItem name="Justificativa de Cargas Paradas" link={getUrl('3.16')}></ListItem>
          </ListItem>
          <ListItem name="Picking" total={6} made={2}>
            <ListItem name="Áreas de Separação"></ListItem>
            <ListItem name="Equipe de Separação"></ListItem>
            <ListItem
              name="Picking - Código de Barra"
              link={getUrl('4.3')}
              disable={false}
              total={11}
              made={10}
            >
              <ListItem name="Editar" link={getUrl('4.3')}></ListItem>
              <ListItem name="Apagar" link={getUrl('4.3')}></ListItem>
              <ListItem name="Assoc Entregas" link={getUrl('4.3.3')}></ListItem>
              <ListItem name="Assoc Areas de Separação" link={getUrl('4.3.4')}></ListItem>
              <ListItem name="Assoc Equipes" link={getUrl('4.3.5')}></ListItem>
              <ListItem name="Preparar para Download" link={getUrl('4.3')}></ListItem>
              <ListItem name="Resumo de Separação" link={getUrl('4.3.7')}></ListItem>
              <ListItem name="Exportar Dados do Picking"></ListItem>
              <ListItem name="Histórico de Leitura" link={getUrl('4.3.9')}></ListItem>
              <ListItem
                name="Formulário Reconferência Faltas e Sobras"
                link={getUrl('4.3.10')}
              ></ListItem>
              <ListItem name="Resumo Separação Analítico" link={getUrl('4.3.11')}></ListItem>
            </ListItem>
            <ListItem name="Picking - Manual" link={getUrl('4.4')} total={5} made={3}>
              <ListItem name="Editar"></ListItem>
              <ListItem name="Apagar"></ListItem>
              <ListItem name="Assoc Entregas" link={getUrl('4.4.3')}></ListItem>
              <ListItem name="Assoc Areas de Separação" link={getUrl('4.4.4')}></ListItem>
              <ListItem name="Resumo de Separação" link={getUrl('4.4.5')}></ListItem>
            </ListItem>
            <ListItem name="Cadastro de Ocorrência"></ListItem>
            <ListItem name="Cargas Pendentes Para Picking"></ListItem>
          </ListItem>
          <ListItem name="Ordem de Coleta" total={5} made={0}>
            <ListItem name="Ordens de Coleta"></ListItem>
            <ListItem name="Aprovação Ordem de Coleta"></ListItem>
            <ListItem name="Local de Descarga"></ListItem>
            <ListItem name="Análise das Ocorrências"></ListItem>
            <ListItem name="Ocorrências Por Colaboradores"></ListItem>
          </ListItem>
          <ListItem name="Patrimônio" total={7} made={0}>
            <ListItem name="Ativo Patrimonial"></ListItem>
            <ListItem name="Movimentação - Recebimento"></ListItem>
            <ListItem name="Movimentação - Devolução"></ListItem>
            <ListItem name="Movimentação - Last Mile"></ListItem>
            <ListItem name="Validação de Canhoto"></ListItem>
            <ListItem name="Saldo Patrimonial por Operação"></ListItem>
            <ListItem name="Pendencias por Transportadora"></ListItem>
          </ListItem>
          <ListItem name="Insumo" total={3} made={0}>
            <ListItem name="Insumo"></ListItem>
            <ListItem name="Entrada e Saída - Insumo"></ListItem>
            <ListItem name="Painel Insumo"></ListItem>
          </ListItem>
        </ol>
      </div>
    </>
  )
}

const ListItem = ({ name, link = null, children, total = null, made = 0, complete = false }) => {
  const [isOpen, setIsOpen] = useState(false)

  const disable = link ? false : true

  const openCollapse = isOpen => {
    setIsOpen(!isOpen)
  }

  return (
    <li
      style={{
        color: !disable || complete ? '#14B0BF' : '#bdbdbd',
        position: 'relative',
        display: 'list-item',
      }}
      className="ListItem"
      type="1"
    >
      {children ? (
        <div
          style={{ position: 'absolute', left: -20, top: 10, color: '#14B0BF' }}
          onClick={() => openCollapse(isOpen)}
        >
          {CollapseIcon(isOpen)}
        </div>
      ) : null}
      <a
        style={{ pointerEvents: !disable ? 'initial' : 'none' }}
        className="ListItemButton"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {name}
      </a>
      {total ? (
        <span style={{ color: '#bdbdbd', fontSize: 12 }}>
          - {made} / {total}
        </span>
      ) : (
        ''
      )}
      {children ? (
        <ol style={{ counterReset: 'item', display: isOpen ? 'block' : 'none' }}>{children}</ol>
      ) : null}
    </li>
  )
}

const CollapseIcon = isOpen => {
  return <>{!isOpen ? <IoIosArrowForward /> : <IoIosArrowDown />}</>
}
